// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"styles__breadcrumbs___19mqc","breadcrumbsItem":"styles__breadcrumbsItem___1LjWu"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/breadcrumbs/styles.css
// module id = XPoP
// module chunks = 2